import { isNullOrEmpty } from "../../../../site-builder/src/util";
import { asisaUnclaimedBenefitsTransitions } from "../../../actions/publicWeb/asisaUnclaimedBenefits";
import { FIELD_STATUS } from "../../../reducers/status";
import {
  getDateOfBirth,
  getFirstname,
  getRecaptcha,
  getSAIdNumber,
  getSurname,
  getGender,
  hasValidSaIdNumber,
} from "../../../selectors/publicWeb/asisaUnclaimedBenefits";

const isValid = (field) => {
  return field && field.status === FIELD_STATUS.VALID;
};

const validateAsisaUnclaimedBenefits = (state) => {
  const hasValidSaIdNumbers = hasValidSaIdNumber(state);
  const saIdNumber = getSAIdNumber(state);
  const firstname = getFirstname(state);
  const surname = getSurname(state);
  const dateOfBirth = getDateOfBirth(state);
  const gender = getGender(state)
  const recaptcha = getRecaptcha(state).value;

  if (hasValidSaIdNumbers) {
    return isValid(saIdNumber) && !isNullOrEmpty(recaptcha);
  }

  return (
    isValid(firstname) &&
    isValid(surname) &&
    isValid(dateOfBirth) &&
    !isNullOrEmpty(gender.value) &&
    !isNullOrEmpty(recaptcha)
  );
};
export const asisaUnclaimedBenefitsFormRules = (store, next, action) => {
  const result = next(action);
  const asisaUnclaimedBenefitsValid = validateAsisaUnclaimedBenefits(
    store.getState()
  );
  store.dispatch(
    asisaUnclaimedBenefitsValid
      ? asisaUnclaimedBenefitsTransitions.formValid()
      : asisaUnclaimedBenefitsTransitions.formInvalid()
  );
  return result;
};
